<div class="header-title">
  Global settings
</div>

<mat-card class="settings-card">
  Cache settings
</mat-card>